import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CognitoAuthProvider,
  OAuthCallbackHandler,
} from "@vault/cognito-auth";
import { storeTokens } from "./lib/tokenStorage";

import { setCredentials } from "./authSlice";
import { getCognitoConfig } from "./lib/cognitoConfig";
import { decodeClaims } from "./lib/decodeClaims";
import { lt } from "./lib/translations";
import Loader from "../../components/Loader";

const AuthCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSuccess = useCallback(
    (tokens) => {
      storeTokens(tokens);
      const { uid, roles } = decodeClaims(tokens.idToken);
      dispatch(setCredentials({ token: tokens.idToken, uid, roles }));
      navigate("/", { replace: true });
    },
    [dispatch, navigate]
  );

  const handleError = useCallback(
    (error) => {
      const params = new URLSearchParams(location.search);
      const description = params.get("error_description");
      const authError =
        description || error?.message || "Prisijungti nepavyko.";
      console.error("OAuth callback error:", authError, error);
      navigate("/login", { replace: true, state: { authError } });
    },
    [location.search, navigate]
  );

  return (
    <CognitoAuthProvider config={getCognitoConfig()} translations={lt}>
      <OAuthCallbackHandler
        onSuccess={handleSuccess}
        onError={handleError}
        loadingContent={<Loader />}
      />
    </CognitoAuthProvider>
  );
};

export default AuthCallback;
